import BaseValidation from '@/forms/Validations/BaseValidation';

import NameValidation from '@/forms/FormElements/Rows/NameRow/NameRow.validation';
import EmailValidation from '@/forms/FormElements/Rows/EmailRow/EmailRow.validation';
import AddressValidation from '@/forms/FormElements/Rows/AddressRow/AddressRow.validation';
import PhoneValidation from '@/forms/FormElements/Rows/PhoneRow/PhoneRow.validation';

import { names } from './BrochureRequestForm.types';
import { required } from 'vuelidate/lib/validators';
import CheckBoxValidation from '@/forms/FormElements/Rows/CheckBoxRow/CheckBox.validation';

const brochureValidation = new BaseValidation([
  {
    name: names.AdditionalBrochures,
    rules: { required },
    messages: {},
    modelValue: false,
  },
]);

export default () => {
  const validations = [
    NameValidation(names.Person),
    EmailValidation(names.Person),
    AddressValidation(names.Address),
    PhoneValidation(names.Phone),
    brochureValidation,
    CheckBoxValidation(),
  ];

  return {
    validations: BaseValidation.getRules(validations),
    messages: BaseValidation.getMessages(validations),
    model: BaseValidation.getModel(validations),
  };
};
